var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding-left":"100px"},attrs:{"fluid":""}},[_c('h1',[_vm._v("プロフィール設定")]),_vm._v(" "),_c('ProfileSettingForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }